import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiSnackbar = (baseTheme: Theme): Partial<Components> => ({
  MuiSnackbar: {
    styleOverrides: {
      root: {
        backgroundColor: baseTheme.palette.common.white,
        borderRadius: '8px',
        '&.MuiSnackbar-anchorOriginTopRight': {
          top: '55px',
          [baseTheme.breakpoints.up('lg')]: {
            marginTop: '20px',
          },
        },
        '& svg': {
          fill: baseTheme.palette.common.white,
        },
        '& .MuiAlert-root': {
          padding: '10px',
        },
        '& .MuiAlert-action': {
          padding: '0 0 0 15px',
          alignSelf: 'flex-start',
          '& svg': {
            width: '16px',
            height: '16px',
            fill: baseTheme.palette.text.primary,
          },
        },
        '& .MuiAlert-icon': {
          marginRight: '15px',
        },
      },
    },
  },
});
